import React from 'react'
import ContactForm from "./ContactForm";
import ContactFormBanner from './ContactFormBanner';
import ContactInfo from './ContactInfo';
import ContactMap from './ContactMap';
import Navbar from "../main_website/Navbar"
import Whatsapp from './Whatsapp';
import Footer from "../main_website/Footer"
const ContactUs = () => {
  return (
    <div>
      <Navbar />
      <ContactFormBanner/><br /><br />
      <ContactForm/><br /><br /><br />
      <ContactInfo/><br /><br /><br />
      <ContactMap/>
      <Whatsapp />
      <Footer />
    </div>
  )
}

export default ContactUs
